export default "__VITE_ASSET__ty785ZQK__"